import { combineReducers } from 'redux';
import publishersTags from './publishers-tags-reducer';

export const publishersTagsReducer = combineReducers({
  publishersTags,
});
